import React from "react";

const SEV = {
    critical: { label: "Critical", color: "#dc2626", bg: "rgba(220,38,38,0.15)" },
    warning:  { label: "Warning",  color: "#f59e0b", bg: "rgba(245,158,11,0.15)" },
    info:     { label: "Info",     color: "#3b82f6", bg: "rgba(59,130,246,0.15)" },
};

export function severityColor(sev) {
    return (SEV[sev] || SEV.info).color;
}

export default function SeverityBadge({ severity }) {
    const cfg = SEV[severity] || { label: severity || "Unknown", color: "#6b7280", bg: "rgba(107,114,128,0.15)" };
    return (
        <span className="rd-severity-badge" style={{ "--rd-badge-color": cfg.color }}>
            {cfg.label}
        </span>
    );
}
